export enum PaymentMethod {
  ACCOUNT = "Account",
  CARD = "Card",
  CASH = "Cash",
  CHEQUE = "Cheque",
  EFT = "EFT",
}

export const ALL_PAYMENT_METHODS = Object.values(PaymentMethod);

export const PAYMENT_METHOD_OPTIONS = ALL_PAYMENT_METHODS.map(
  paymentMethod => ({
    label: paymentMethod,
    value: paymentMethod,
  }),
);

export interface BuyerPaymentSummaryTotals {
  amountExclCents: number;
  feesCents: number;
  taxCents: number;
  dueCents: number;
}

export interface BuyerPaymentSummaryItem {
  lotId: string;
  lotTitle: string;
  quantity: number;
  amountInclCents: number;
}

export interface BuyerPaymentSummaryData {
  items: BuyerPaymentSummaryItem[];
  totals: BuyerPaymentSummaryTotals;
}

export const EMPTY_SUMMARY_DATA: BuyerPaymentSummaryData = {
  items: [],
  totals: {
    amountExclCents: 0,
    feesCents: 0,
    taxCents: 0,
    dueCents: 0,
  },
};
